import type { ComponentPropsWithoutRef } from 'react'
import { RecentCheckInsSection } from '@/components/intake/RecentCheckInsSection'
import type { CheckedInExhibit } from '@/hooks/useEntryIntake'
import { useRecentCheckIns } from '@/hooks/useRecentCheckIns'
import { RECENT_EVENTS_STORAGE_KEY } from '@/features/intake/utils'

type SectionProps = ComponentPropsWithoutRef<typeof RecentCheckInsSection>

type RecentCheckInsProps = Omit<
  SectionProps,
  'events' | 'collapsed' | 'onToggleCollapsed' | 'listId'
> & {
  events: CheckedInExhibit[]
  showId?: string | null
  defaultCollapsed?: boolean
  listIdPrefix?: string
  storageKey?: string
  limit?: number
}

export function RecentCheckIns({
  events,
  showId = null,
  defaultCollapsed = true,
  listIdPrefix,
  storageKey = RECENT_EVENTS_STORAGE_KEY,
  limit,
  ...sectionProps
}: RecentCheckInsProps) {
  const {
    events: normalizedEvents,
    collapsed,
    listId,
    toggleCollapsed,
  } = useRecentCheckIns({
    events,
    showId,
    defaultCollapsed,
    listIdPrefix,
    storageKey,
    limit,
  })

  if (normalizedEvents.length === 0) {
    return null
  }

  return (
    <RecentCheckInsSection
      events={normalizedEvents}
      collapsed={collapsed}
      onToggleCollapsed={toggleCollapsed}
      listId={listId}
      {...sectionProps}
    />
  )
}
